import { render, staticRenderFns } from "./NewOrdersTable.vue?vue&type=template&id=183e34d4&scoped=true"
import script from "./NewOrdersTable.vue?vue&type=script&lang=js"
export * from "./NewOrdersTable.vue?vue&type=script&lang=js"
import style1 from "./NewOrdersTable.vue?vue&type=style&index=1&id=183e34d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e34d4",
  null
  
)

export default component.exports